





























































































































































































import mixins from 'vue-typed-mixins'
import DraftActions from '@/builder/mixins/DraftActions'
import { DraftActionsType } from '@/calendesk/models/DraftActionsType'
import TipTap from '@/lib/calendesk-js-library/components/TipTap.vue'
import SettingTooltip from '@/components/Tools/SettingTooltip.vue'
import PagesSingleSelect from '@/builder/sidebar/sidebarDetails/components/PageSingleSelect.vue'
import Page from '@/calendesk/models/DTO/Response/Page'
import { BuilderSelectType } from '@/calendesk/models/BuilderSelectType'
import CalendeskInformationMessage from '@/lib/calendesk-js-library/components/CalendeskInformationMessage.vue'
import CalendeskWarningMessage from '@/lib/calendesk-js-library/components/CalendeskWarningMessage.vue'
import {
  categoryVisibilityKey,
  CookieReopen,
  COOKIE_REOPEN_KEY,
  COOKIE_SETTINGS_HASH,
  draftLinksToCookieSettings,
  ConsentCategory,
  COOKIE_BANNER_REVISION_KEY,
  OPTIONAL_CATEGORIES,
  PRIVACY_POLICY_TARGET_KEY,
  PrivacyPolicyTarget
} from '@/calendesk/models/CookieBannerSettings'

// The banner's own editor: the generic external-configuration editor cannot
// offer an HTML field or show one of two link fields depending on a choice.
// Writes go through DraftActions in external-configuration mode, so they land
// on configuration id 5 with the same buffering and undo steps as every panel.
export default mixins(DraftActions).extend({
  name: 'CookieBannerConfiguration',
  components: { CalendeskInformationMessage, CalendeskWarningMessage, PagesSingleSelect, SettingTooltip, TipTap },
  data () {
    return {
      mode: DraftActionsType.EXTERNAL_CONFIGURATION,
      form: {} as Record<string, any>,
      categories: ['necessary', 'functionality', 'analytics', 'marketing'],
      optionalCategories: OPTIONAL_CATEGORIES,
      privacyPolicyTargets: PrivacyPolicyTarget,
      cookieReopen: CookieReopen,
      cookieSettingsHash: COOKIE_SETTINGS_HASH
    }
  },
  computed: {
    reopen (): CookieReopen {
      return this.form[COOKIE_REOPEN_KEY]?.value || CookieReopen.ICON
    },
    reopenItems (): Array<Record<string, string>> {
      return [
        { text: this.$trans('wb_cookie_banner_reopen_icon'), value: CookieReopen.ICON },
        { text: this.$trans('wb_cookie_banner_reopen_link'), value: CookieReopen.LINK },
        { text: this.$trans('wb_cookie_banner_reopen_both'), value: CookieReopen.BOTH }
      ]
    },
    linksToCookieSettings (): boolean {
      return draftLinksToCookieSettings(this.draft)
    },
    privacyPolicyTarget (): PrivacyPolicyTarget {
      return this.form[PRIVACY_POLICY_TARGET_KEY]?.value || PrivacyPolicyTarget.NONE
    },
    privacyPolicyTargetItems (): Array<Record<string, string>> {
      return [
        { text: this.$trans('wb_cookie_banner_privacy_policy_target_none'), value: PrivacyPolicyTarget.NONE },
        { text: this.$trans('wb_cookie_banner_privacy_policy_target_page'), value: PrivacyPolicyTarget.PAGE },
        { text: this.$trans('wb_cookie_banner_privacy_policy_target_url'), value: PrivacyPolicyTarget.URL }
      ]
    }
  },
  watch: {
    selectedExternalConfiguration: {
      immediate: true,
      handler (configuration: Record<string, any> | null) {
        // Only an outside change (undo, a fresh selection) rebuilds the form;
        // the tenant's own keystrokes are already in it.
        this.form = { ...(configuration || {}) }
      }
    }
  },
  methods: {
    categoryVisibilityKey,
    text (key: string, fallbackKey: string): string {
      const value = this.form[key]
      return typeof value === 'string' && value.trim() !== '' ? value : this.$trans(fallbackKey)
    },
    update (key: string, value: any, immediately = false) {
      this.updateConfigurationProperty(key, value, immediately)
    },
    // Which categories exist changes what the site may load, so visitors who
    // already answered are asked again.
    updateCategoryVisibility (category: ConsentCategory, visible: boolean) {
      const key = categoryVisibilityKey(category)
      this.$set(this.form, key, visible)
      this.update(key, visible, true)

      const revision = this.draft.configuration[COOKIE_BANNER_REVISION_KEY]
      this.$store.dispatch('builder/updateDraftConfigurationProperty', {
        [COOKIE_BANNER_REVISION_KEY]: (typeof revision === 'number' ? revision : 0) + 1
      })
    },
    updateReopen (value: CookieReopen) {
      this.$set(this.form, COOKIE_REOPEN_KEY, { type: BuilderSelectType.COOKIE_REOPEN, value })
      this.update(COOKIE_REOPEN_KEY, this.form[COOKIE_REOPEN_KEY], true)
    },
    updatePrivacyPolicyTarget (value: PrivacyPolicyTarget) {
      this.$set(this.form, PRIVACY_POLICY_TARGET_KEY, { type: BuilderSelectType.PRIVACY_POLICY_TARGET, value })
      this.update(PRIVACY_POLICY_TARGET_KEY, this.form[PRIVACY_POLICY_TARGET_KEY], true)
    },
    updateSelectedPage (page: Page | null) {
      const uuid = page ? page.uuid : null
      this.$set(this.form, 'wb_cookie_banner_privacy_policy_page__page_id__', uuid)
      this.update('wb_cookie_banner_privacy_policy_page__page_id__', uuid, true)
    }
  }
})
